var _rect, _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrontendService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64px",
    height: "64px",
    transform: "rotate(0) scale(1, 1)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Development") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Development",
    className: "",
    fillOpacity: 1,
    fill: "#3d43ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63,4H35V1a1,1,0,0,0-2,0V4H1A1,1,0,0,0,0,5V59a1,1,0,0,0,1,1H33v3a1,1,0,0,0,2,0V60H63a1,1,0,0,0,1-1V5A1,1,0,0,0,63,4ZM62,6v6H35V6ZM2,6H33v6H2ZM2,58V14H33V58Zm33,0V14H62V58Z",
    id: "svg_1",
    fill: "#3d43ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,8a1,1,0,0,0,0,2A1,1,0,0,0,6,8Z",
    id: "svg_2",
    fill: "#3d43ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,8a1,1,0,0,0,0,2A1,1,0,0,0,11,8Z",
    id: "svg_3",
    fill: "#3d43ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,8a1,1,0,0,0,0,2A1,1,0,0,0,16,8Z",
    id: "svg_4",
    fill: "#3d43ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,17H6a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1V18A1,1,0,0,0,29,17Zm-1,9H7V19H28Z",
    id: "svg_5",
    fill: "#3d43ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5,31A3.5,3.5,0,1,0,30,34.5,3.5,3.5,0,0,0,26.5,31Zm0,5a1.5,1.5,0,0,1,0-3A1.5,1.5,0,0,1,26.5,36Z",
    id: "svg_6",
    fill: "#3d43ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,38A3.5,3.5,0,1,0,14,34.5,3.5,3.5,0,0,0,17.5,38Zm0-5a1.5,1.5,0,0,1,0,3A1.5,1.5,0,0,1,17.5,33Z",
    id: "svg_7",
    fill: "#3d43ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,38A3.5,3.5,0,1,0,5,34.5,3.5,3.5,0,0,0,8.5,38Zm0-5a1.5,1.5,0,0,1,0,3A1.5,1.5,0,0,1,8.5,33Z",
    id: "svg_8",
    fill: "#3d43ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,40H24a1,1,0,0,0,0,2h5A1,1,0,0,0,29,40Z",
    id: "svg_9",
    fill: "#3d43ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,44H24a1,1,0,0,0,0,2h5A1,1,0,0,0,29,44Z",
    id: "svg_10",
    fill: "#3d43ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,42h5a1,1,0,0,0,0-2H15A1,1,0,0,0,15,42Z",
    id: "svg_11",
    fill: "#3d43ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,46h5a1,1,0,0,0,0-2H15A1,1,0,0,0,15,46Z",
    id: "svg_12",
    fill: "#3d43ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,42h5a1,1,0,0,0,0-2H6A1,1,0,0,0,6,42Z",
    id: "svg_13",
    fill: "#3d43ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,46h5a1,1,0,0,0,0-2H6A1,1,0,0,0,6,46Z",
    id: "svg_14",
    fill: "#3d43ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,49H6a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1V50A1,1,0,0,0,29,49Zm-1,4H7V51H28Z",
    id: "svg_15",
    fill: "#3d43ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.29,26.71a1,1,0,0,0,1.42-1.42L39.41,22l3.3-3.29a1,1,0,0,0-1.42-1.42l-4,4a1,1,0,0,0,0,1.42Z",
    id: "svg_16",
    fill: "#3d43ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.71,17.29a1,1,0,0,0-1.42,1.42L57.59,22l-3.3,3.29A1,1,0,0,0,55,27c.56,0,.3.12,4.71-4.29a1,1,0,0,0,0-1.42Z",
    id: "svg_17",
    fill: "#3d43ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.85,26.53l5-8a1,1,0,0,0-1.7-1.06l-5,8A1,1,0,0,0,46.85,26.53Z",
    id: "svg_18",
    fill: "#3d43ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,31H38a1,1,0,0,0,0,2H59A1,1,0,0,0,59,31Z",
    id: "svg_19",
    fill: "#3d43ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,38H52a1,1,0,0,0,0-2H38A1,1,0,0,0,38,38Z",
    id: "svg_20",
    fill: "#3d43ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,43H56a1,1,0,0,0,0-2H38A1,1,0,0,0,38,43Z",
    id: "svg_21",
    fill: "#3d43ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,46H38a1,1,0,0,0,0,2H59A1,1,0,0,0,59,46Z",
    id: "svg_22",
    fill: "#3d43ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,51H38a1,1,0,0,0,0,2H54A1,1,0,0,0,54,51Z",
    id: "svg_23",
    fill: "#3d43ac"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontendService);
export default __webpack_public_path__ + "static/media/frontend-service.1aa8155d1cb61bf79a2bce5b96f6723a.svg";
export { ForwardRef as ReactComponent };